import React, { useState } from 'react';
import { FaStar, FaChevronLeft, FaChevronRight, FaUserCircle, FaUserTie, FaHardHat } from 'react-icons/fa';
import './Testimonials.css';

const testimonials = [
  {
    name: 'Michael R.',
    role: 'Shop Owner, Dallas TX',
    avatar: <FaHardHat />,
    rating: 5,
    text: "NX Auto Care has been my go-to for OEM parts for 3 years. Their prices are unbeatable and the parts always arrive fast and properly packaged. I've saved thousands compared to dealer pricing.",
  },
  {
    name: 'Sarah L.',
    role: 'DIY Mechanic, Atlanta GA',
    avatar: <FaUserCircle />,
    rating: 5,
    text: 'I was skeptical about ordering used OEM parts online, but NX Auto Care completely changed my mind. The alternator I ordered for my Civic was perfect and has been running great for 8 months.',
  },
  {
    name: 'James T.',
    role: 'Fleet Manager, Chicago IL',
    avatar: <FaUserTie />,
    rating: 5,
    text: "Managing 40+ vehicles, I need a reliable parts supplier. NX Auto Care delivers consistently — right parts, right price, on time. Their trade account program saved our company over $18K last year.",
  },
  {
    name: 'Carlos M.',
    role: 'Auto Repair Tech, Miami FL',
    avatar: <FaHardHat />,
    rating: 5,
    text: 'The fitment guarantee is what sold me. I ordered a transmission for a 2017 Accord, it was exactly right. No guessing, no returns. That kind of accuracy is rare in this industry.',
  },
  {
    name: 'Linda K.',
    role: 'Vehicle Owner, Phoenix AZ',
    avatar: <FaUserCircle />,
    rating: 5,
    text: 'My BMW needed a water pump and the dealership quoted $650. AutoPrime had the OEM part for $180 and it arrived in 2 days. Saved over $400! The quality was indistinguishable from dealer parts.',
  },
  {
    name: 'Derek W.',
    role: 'Classic Car Restorer, Nashville TN',
    avatar: <FaUserTie />,
    rating: 5,
    text: 'Finding parts for vintage vehicles is usually a nightmare. AutoPrime tracked down a carburetor for my 1978 Chevy pickup in less than 24 hours. Incredible service and genuine passion for cars.',
  },
];

const Testimonials = () => {
  const [current, setCurrent] = useState(0);
  const visible = 3;
  const total = testimonials.length;

  const prev = () => setCurrent((c) => (c - 1 + total) % total);
  const next = () => setCurrent((c) => (c + 1) % total);

  const displayed = [];
  for (let i = 0; i < visible; i++) {
    displayed.push(testimonials[(current + i) % total]);
  }

  return (
    <section className="testimonials">
      <div className="testimonials-container">
        <div className="section-header">
          <div className="section-badge">CUSTOMER REVIEWS</div>
          <h2>What Our Customers Say</h2>
          <p>Real feedback from real customers who trust AutoPrime for their parts needs.</p>
        </div>

        <div className="testimonials-grid">
          {displayed.map((t, i) => (
            <div className="testimonial-card" key={i}>
              <div className="stars">
                {Array.from({ length: t.rating }).map((_, s) => (
                  <FaStar key={s} className="star-icon" />
                ))}
              </div>
              <p className="review-text">"{t.text}"</p>
              <div className="reviewer">
                <div className="reviewer-avatar">{t.avatar}</div>
                <div className="reviewer-info">
                  <strong>{t.name}</strong>
                  <span>{t.role}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="testimonials-nav">
          <button className="nav-btn" onClick={prev}><FaChevronLeft /></button>
          <div className="dots">
            {testimonials.map((_, i) => (
              <button
                key={i}
                className={`dot ${current === i ? 'active' : ''}`}
                onClick={() => setCurrent(i)}
              />
            ))}
          </div>
          <button className="nav-btn" onClick={next}><FaChevronRight /></button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
